export const DASHBOARD_VERSION =
  process.env.REACT_APP_DASHBOARD_VERSION || "1.0.4";
